export enum PlatformLinkingStoreStatus {
  Loading = 'Loading',
  LoadingPkce = 'loading_pkce',
  Unlinking = 'Unlinking',
}
